<form [formGroup]="form" novalidate autocomplete="off">
  <div class="modal-dialog-header">
    <button
      type="button"
      tabindex="-1"
      class="close float-right"
      data-dismiss="modal"
      aria-label="Close"
      (click)="cancel()"
      title="Close form and discard any changes."
    >
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
    <h3 mat-dialog-title>{{ data.title }}</h3>
  </div>
  <mat-dialog-content class="modal-dialog-content">
    <div class="form-group">
      <label for="name">Name</label> <input cdkFocusInitial formControlName="name" type="text" class="form-control" />
      <p *ngIf="form.get('name').invalid && form.get('name').dirty" class="text-danger">
        A Name for this report is required
      </p>
    </div>
    <div class="form-group">
      <label for="url">URL</label> <input formControlName="url" type="text" class="form-control" />
      <p *ngIf="form.get('url').invalid && form.get('url').dirty" class="text-danger">
        A URL for this report is required
      </p>
    </div>
    <div class="form-group">
      <label for="description">Description</label>
      <input formControlName="description" type="text" class="form-control" />
      <p *ngIf="form.get('description').invalid && form.get('description').dirty" class="text-danger">
        A Description for this report is required
      </p>
    </div>
  </mat-dialog-content>
  <div class="modal-dialog-footer">
    <button type="button" class="btn btn-default float-left btn-sm" (click)="cancel()">
      <fa-icon [icon]="faTimes"></fa-icon> Cancel
    </button>
    <button type="button" (submitIfValid)="save()" [form]="form" class="btn btn-primary float-right btn-sm">
      <fa-icon [icon]="faSave"></fa-icon> Save
    </button>
  </div>
</form>
